import types from 'redux/types';
import { checkTypeValue } from 'helpers';
import {
  baseCreative,
  fetchUpdateCreativeCampaign,
  fetchUpdateCreativeCampaignSuccess,
  fetchUpdateCreativeCampaignFailed,
  fetchFilterCreative,
  fetchFilterCreativeSuccess,
  fetchFilterCreativeFailed,
  fetchUpdateCreative,
  fetchUpdateCreativeSuccess,
  fetchUpdateCreativeFailed,
  fetchCreativeByID,
  fetchCreativeByIDSuccess,
  fetchCreativeByIDFailed,
  fetchDeleteCreative,
  fetchDeleteCreativeSuccess,
  fetchDeleteCreativeFailed,
  fetchCreateCreative,
  fetchCreateCreativeSuccess,
  fetchCreateCreativeFailed,
  fetchListCreative,
  fetchListCreativeSuccess,
  fetchListCreativeFailed,
} from 'redux/handleReducers/creative';
import components, { typeUnmounted } from 'consts/components';

const initialState = {
  ...baseCreative(),
};

export default (state, actions) => {
  if (checkTypeValue(state, 'undefined')) {
    return initialState;
  }

  switch (actions.type) {
    case types.REQUEST_UPDATE_CREATIVE_CAMPAIGN:
      return fetchUpdateCreativeCampaign(actions, state);

    case types.REQUEST_UPDATE_CREATIVE_CAMPAIGN_SUCCESS:
      return fetchUpdateCreativeCampaignSuccess(actions, state);

    case types.REQUEST_UPDATE_CREATIVE_CAMPAIGN_FAILED:
      return fetchUpdateCreativeCampaignFailed(actions, state);

    case types.REQUEST_FILTER_CREATIVE:
      return fetchFilterCreative(actions, state);

    case types.REQUEST_FILTER_CREATIVE_SUCCESS:
      return fetchFilterCreativeSuccess(actions, state);

    case types.REQUEST_FILTER_CREATIVE_FAILED:
      return fetchFilterCreativeFailed(actions, state);

    case types.REQUEST_UPDATE_CREATIVE:
      return fetchUpdateCreative(actions, state);

    case types.REQUEST_UPDATE_CREATIVE_SUCCESS:
      return fetchUpdateCreativeSuccess(actions, state);

    case types.REQUEST_UPDATE_CREATIVE_FAILED:
      return fetchUpdateCreativeFailed(actions, state);

    case types.REQUEST_GET_CREATIVE_BY_ID:
      return fetchCreativeByID(actions, state);

    case types.REQUEST_GET_CREATIVE_BY_ID_SUCCESS:
      return fetchCreativeByIDSuccess(actions, state);

    case types.REQUEST_GET_CREATIVE_BY_ID_FAILED:
      return fetchCreativeByIDFailed(actions, state);

    case types.REQUEST_DELETE_CREATIVE:
      return fetchDeleteCreative(actions, state);

    case types.REQUEST_DELETE_CREATIVE_SUCCESS:
      return fetchDeleteCreativeSuccess(actions, state);

    case types.REQUEST_DELETE_CREATIVE_FAILED:
      return fetchDeleteCreativeFailed(actions, state);

    case types.REQUEST_CREATE_CREATIVE:
      return fetchCreateCreative(actions, state);

    case types.REQUEST_CREATE_CREATIVE_SUCCESS:
      return fetchCreateCreativeSuccess(actions, state);

    case types.REQUEST_CREATE_CREATIVE_FAILED:
      return fetchCreateCreativeFailed(actions, state);

    case types.REQUEST_GET_LIST_CREATIVE:
      return fetchListCreative(actions, state);

    case types.REQUEST_GET_LIST_CREATIVE_SUCCESS:
      return fetchListCreativeSuccess(actions, state);

    case types.REQUEST_GET_LIST_CREATIVE_FAILED:
      return fetchListCreativeFailed(actions, state);

    case typeUnmounted(components.creative):
      return {
        ...state,
        creative: {},
      };

    default:
      return state;
  }
};
